module.exports = __webpack_public_path__ + "07fa0929f525cd743d8a2114f70b6f6e.pdf";